import type { Root } from 'hast';
import { toString } from 'hast-util-to-string';

// type Compiler = import('unified').Compiler<Root, string>;

export type Processor = import('unified').Processor<
  undefined,
  undefined,
  undefined,
  Root,
  string
>;

export default function rehypeText() {
  // @ts-expect-error: TypeScript doesn’t handle `this` well.
  const self: Processor = this as Processor;

  self.compiler = function compiler(tree) {
    return toString(tree);
  };
}
